import paper from 'paper';
import WarpTransformer, { WarpFormControl } from './WarpForm.js';
import { calculateControlVector, transformFlip } from '../Utils.js';
import { reverseShapes } from '../SvgUtils.js';
import { getSampleWarpShape, samplesWarpShape } from './WarpSamples.js';

export const transformTypes = {
    warpForm: 'warpForm',
    resetFrom: 'resetFrom'
};

const defaultTransform = {
    [transformTypes.resetFrom]: getSampleWarpShape(samplesWarpShape.resetFrom),
    [transformTypes.warpForm]: getSampleWarpShape(samplesWarpShape.warpForm)
};

const controlHandlers = {
    [transformTypes.warpForm]: WarpFormControl,
    [transformTypes.resetFrom]: WarpFormControl
};

export const getControlHandler = (control) => {
    return controlHandlers[control];
};

export const getDefaultTransform = (type) => {
    return defaultTransform[type];
};

export function processTextTransform(pathData, transformOptions, neutralOptions) {
    // Asegurar que paths sea un array
    const pathDataArray = Array.isArray(pathData) ? [...pathData] : [pathData];

    // Procesar transformación de forma libre o reset
    if (
        [transformTypes.warpForm, transformTypes.resetFrom].includes(transformOptions.type) &&
        transformOptions.points
    ) {
        if (transformOptions.flipX || transformOptions.flipY) {
            points = transformFlip(points, transformOptions.flipX, transformOptions.flipY);
        }

        const transformer = new WarpTransformer({
            points: transformOptions.points,
            bounds: neutralOptions.bounds,
            flipX: neutralOptions.flipX || false,
            flipY: neutralOptions.flipY || false
        });

        // Procesar cada path
        const transformedPaths = pathData.map((path) => {
            // Transformar coordenadas usando expresión regular
            const transformed = new paper.CompoundPath(
                path.replace(/([-eE\d]+\.?[-eE\d]*)\s([-eE\d]+\.?[-eE\d]*)/gm, (match) =>
                    transformer.getTransformedCoordinatesString(match)
                )
            );
            // Invertir shapes si es necesario para mantener la dirección original
            reverseShapes(transformed);
            return transformed.pathData;
        });
        const combinedPathData = transformedPaths.join(' ');

        const resultBounds = new paper.CompoundPath({
            pathData: combinedPathData,
            insert: false
        }).bounds;

        return {
            path: combinedPathData,
            paths: transformedPaths,
            controlVector: calculateControlVector(resultBounds, transformer.points[0], {
                flipX: neutralOptions.flipX,
                flipY: neutralOptions.flipY
            }),
            bounds: {
                minX: resultBounds.x,
                maxX: resultBounds.right,
                minY: -resultBounds.y,
                maxY: -resultBounds.bottom
            }
        };
    }

    // Si no hay transformación, retornar paths originales
    return {
        path: pathDataArray.join(''),
        paths: pathDataArray,
        bounds: neutralOptions.bounds
    };
}
